import './LoadPage.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

/**
 * Simple loadpage.
 * 
 * @param {bool} light
 *    Set to true to render a light version.
 */
function LoadPage({
  light = false,
  fill = true,
  text = "Please wait while we get everything ready for you...",
  ...props
}) {
  function getRollerClass() {
    return(
      light ? "lds-roller light" : "lds-roller"
    );
  }

  function getDivClass() {
    return(`${fill ? "fill" : ""} text-center align-middle mb-0 ${light ? "bg-white" : "bg-primary"} ${light ? "text-primary" : "text-white"}`);
  }

  return (
    <Container fluid className={ getDivClass() }>
      <Row className="h-100 mb-0 me-0">
        <Col className="my-auto">
          <div className={ getRollerClass() }>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
          </div>
          <p>
            {text}
          </p>
        </Col>
      </Row>
    </Container>
  );
}

LoadPage.propTypes = {
  /**
   * Whether the loader should have a light or dark background.
   */
  light: PropTypes.bool,
  /**
   * Whether the loader should fill its container.
   */
  fill: PropTypes.bool,
  /**
   * Text to display in the loader.
   */
  text: PropTypes.string,
};

export default LoadPage;